import PolarisIcon from '../PolarisIcon';
import { IconButton } from '@mui/material';
import styled from '@emotion/styled';

type RemoveButtonProps = {
  onClick: () => void;
  className?: string;
};

const RemoveButton = ({ onClick, className = '', ...props }: RemoveButtonProps) => {
  return (
    <StyledIconButton color="default" className={className} onClick={onClick} {...props}>
      <PolarisIcon icon="close" />
    </StyledIconButton>
  );
};

export default RemoveButton;

const StyledIconButton = styled(IconButton)`
  opacity: 0.5;
  transition: ease opacity 0.2s;
  &:hover {
    opacity: 1;
    transition: ease opacity 0.2s;
  }
`;
